import React from "react";
import { MagazineImageContext } from "./MagazineImageContext";

export const useMagazineImageContext = () => {
  const context = React.useContext(MagazineImageContext);
  if (!context) {
    throw new Error('useMagazineImageContext must be used within a MagazineImageContextProvider');
  }
  return context;
}